import moment from 'moment';

import {
    BOOKING_STATUS_UNAPPROVED,
    BOOKING_STATUS_APPROVED,
    BOOKING_STATUS_CHECKED_OUT,
    BOOKING_STATUS_CHECKED_IN,
    BOOKING_STATUS_CANCELLED,
} from '../booking';

export const BOOKINGS = {
    0: {
        staticUId: `0`,
        versionedUId: `0`,
        vehiclePlantId: 1,
        driverPersonId: 1,
        startTime: moment({ h: 6 }).format(`YYYY-MM-DD HH:mm:ss`),
        checkOutTime: moment({ h: 6, m: 5 }).format(`YYYY-MM-DD HH:mm:ss`),
        endTime: moment(7, `HH`).format(`YYYY-MM-DD HH:mm:ss`),
        checkInTime: moment({ h: 6, m: 59 }).format(`YYYY-MM-DD HH:mm:ss`),
        statusId: BOOKING_STATUS_CHECKED_IN,
        passengerPersonIds: null,
        pickupLocationId: 1,
        journeyToLocationId: 2,
        returnToLocationId: 1,
        reasonForTravel: `Breakfast`,
        actionPermissions: {
            allowedStatusIdTransitions: null,
        },
        additionalPlantIds: [5],
        privateUse: false,
    },
    1: {
        staticUId: `1`,
        versionedUId: `1`,
        vehiclePlantId: 1,
        driverPersonId: 1,
        startTime: moment({ h: 9 }).format(`YYYY-MM-DD HH:mm:ss`),
        checkOutTime: moment({ h: 8, m: 55 }).format(`YYYY-MM-DD HH:mm:ss`),
        endTime: moment(11, `HH`).format(`YYYY-MM-DD HH:mm:ss`),
        checkInTime: null,
        statusId: BOOKING_STATUS_CHECKED_OUT,
        passengerPersonIds: [2, 3],
        pickupLocationId: 1,
        journeyToLocationId: 2,
        returnToLocationId: 1,
        reasonForTravel: `Meeting`,
        actionPermissions: {
            allowedStatusIdTransitions: [BOOKING_STATUS_CHECKED_IN],
        },
        additionalPlantIds: [4, 5],
        privateUse: true,
    },
    2: {
        staticUId: `2`,
        versionedUId: `2`,
        vehiclePlantId: 2,
        driverPersonId: 2,
        startTime: moment(15, `HH`).format(`YYYY-MM-DD HH:mm:ss`),
        checkOutTime: null,
        endTime: moment(17, `HH`).add(3, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkInTime: null,
        statusId: BOOKING_STATUS_APPROVED,
        passengerPersonIds: [1, 3],
        pickupLocationId: 1,
        journeyToLocationId: 2,
        returnToLocationId: 1,
        reasonForTravel: ``,
        actionPermissions: {
            allowedStatusIdTransitions: null,
        },
        privateUse: false,
    },
    3: {
        staticUId: `3`,
        versionedUId: `3`,
        vehiclePlantId: 3,
        driverPersonId: 1,
        startTime: moment(11, `HH`).add(1, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkOutTime: moment(11, `HH`).subtract(1, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        endTime: moment(13, `HH`).add(6, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkInTime: null,
        statusId: BOOKING_STATUS_CHECKED_OUT,
        passengerPersonIds: [2, 3],
        pickupLocationId: 1,
        journeyToLocationId: 2,
        returnToLocationId: 1,
        reasonForTravel: ``,
        actionPermissions: {
            allowedStatusIdTransitions: [BOOKING_STATUS_CHECKED_IN],
        },
        privateUse: true,
    },
    4: {
        staticUId: `4`,
        versionedUId: `4`,
        vehiclePlantId: 1,
        driverPersonId: 1,
        startTime: moment(9, `HH`).add(2, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkOutTime: null,
        endTime: moment(9, `HH`).add(15, `m`).add(2, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkInTime: null,
        statusId: BOOKING_STATUS_UNAPPROVED,
        passengerPersonIds: [2, 3],
        pickupLocationId: 1,
        journeyToLocationId: 2,
        returnToLocationId: 1,
        reasonForTravel: ``,
        actionPermissions: {
            allowedStatusIdTransitions: [BOOKING_STATUS_CANCELLED],
        },
        privateUse: false,
    },
    5: {
        staticUId: `5`,
        versionedUId: `5`,
        vehiclePlantId: 2,
        driverPersonId: 1,
        startTime: moment(8, `HH`).add(10, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkOutTime: null,
        endTime: moment(14, `HH`).add(10, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkInTime: null,
        statusId: BOOKING_STATUS_CANCELLED,
        passengerPersonIds: [2, 3],
        pickupLocationId: 1,
        journeyToLocationId: 2,
        returnToLocationId: 1,
        reasonForTravel: ``,
        actionPermissions: {
            allowedStatusIdTransitions: null,
        },
        privateUse: true,
    },
    6: {
        staticUId: `6`,
        versionedUId: `6`,
        vehiclePlantId: 1,
        driverPersonId: 1,
        startTime: moment(14, `HH`).add(10, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkOutTime: null,
        endTime: moment(9, `HH`).add(11, `d`).format(`YYYY-MM-DD HH:mm:ss`),
        checkInTime: null,
        statusId: BOOKING_STATUS_APPROVED,
        passengerPersonIds: [2, 3],
        pickupLocationId: 1,
        journeyToLocationId: 2,
        returnToLocationId: 1,
        reasonForTravel: ``,
        actionPermissions: {
            allowedStatusIdTransitions: [BOOKING_STATUS_CHECKED_OUT, BOOKING_STATUS_CANCELLED],
        },
        privateUse: false,
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/bookings.js